export const CHAT_KEY = 'yl7zuyrsbjaxwhwwbcsfajhmlf7nlnuc';
